/**
 * UI Reducers
 */
/* tslint:disable:max-line-length */
import * as action from '../actions/ui';

import { reducerWithInitialState } from 'typescript-fsa-reducers';

type ReducerState = IUIState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;

const initialState: ReducerState = {
  header: {
    type: 'simple',
    visible: true,
  },
  licenseBar: {
    heightPx: 64,
    visible: false,
  },
};

const pageIsScrollingHandler: Handler<boolean> =
  (state, pageIsScrolling) => ({ ...state, pageIsScrolling });

const toggleLicenseBarVisibilityHandler: Handler<boolean> =
  (state, visible) => ({ ...state, licenseBar: { ...state.licenseBar!, visible } });

const setLicenseBarHeightHandler: Handler<number> =
  (state, heightPx) => ({ ...state, licenseBar: { ...state.licenseBar!, heightPx } });

const toggleHeaderVisibilityHandler: Handler<boolean> =
  (state, visible) => ({ ...state, header: { ...state.header, visible } });

const toggleTrackDetailsVisibilityHandler: Handler<boolean> =
  (state, visible) => ({ ...state, trackDetails: { ...state.trackDetails, visible } });

const toggleAddToProjectVisibilityHandler: Handler<boolean> =
  (state, visible) => ({
    ...state,
    addToProject: visible ? {
      ...(state.addToProject ? state.addToProject : { trackId: undefined, trackVersion: undefined}),
      visible,
    } : undefined,
  });

const showTrackDetailsHandler: Handler<IShowTrackDetailsActionPayload> =
  (state, { cartLineItemId, license, trackInfo }) => ({
    ...state,
    trackDetails: {
      visible: true,
      license,
      trackInfo,
      cartLineItemId,
    },
  });

const toggleSignUpFormVisibilityHandler: Handler<boolean> = (state, visible) => ({ ...state, signUpForm: { visible } });
const toggleLogInFormVisibilityHandler: Handler<boolean> = (state, visible) => ({ ...state, logInForm: { visible } });
const togglePlayerTermListVisibilityHandler: Handler<boolean> = (state, visible) => ({ ...state, player: { termListIsVisible: visible, visible } });

const showAddTrackToProjectFormHandler: Handler<IShowAddToProjectFormActionPayload> =
  (state, { trackId, trackVersion }) => ({
    ...state,
    addToProject: {
      visible: true,
      trackId,
      trackVersion,
    },
  });

const showDownloadAgreementModalHandler: Handler<IShowDownloadAgreementModalActionPayload> =
  (state, { filePath, track }) => ({
    ...state,
    downloadAgreementModal: {
      filePath,
      track,
    },
  });

const showSignUpFormHandler: Handler<IShowSignUpFormActionPayload> =
  (state, { reason }) => ({
    ...state,
    signUpForm: {
      visible: true,
      reason,
    },
  });

const setHeaderTypeHandler: Handler<{ type: HeaderType }> =
  (state, { type }) => ({ ...state, header: { ...state.header, type } });

const setHeaderActionsHandler: Handler<{ actions: JSX.Element[] }> =
  (state, { actions }) => ({ ...state, header: { ...state.header, actions } });

const clearUIStateHandler: Handler<keyof ReducerState> =
  (state, key) => ({ ...state, [key]: undefined });

export default reducerWithInitialState(initialState)
  .case(action.pageIsScrolling, pageIsScrollingHandler)
  .case(action.showAddTrackToProjectForm, showAddTrackToProjectFormHandler)
  .case(action.toggleLicenseBarVisibility, toggleLicenseBarVisibilityHandler)
  .case(action.setLicenseBarHeight, setLicenseBarHeightHandler)
  .case(action.toggleLogInFormVisibility, toggleLogInFormVisibilityHandler)
  .case(action.toggleHeaderVisibility, toggleHeaderVisibilityHandler)
  .case(action.toggleTrackDetailsVisibility, toggleTrackDetailsVisibilityHandler)
  .case(action.toggleAddToProjectVisibility, toggleAddToProjectVisibilityHandler)
  .case(action.showTrackDetails, showTrackDetailsHandler)
  .case(action.toggleSignUpFormVisibility, toggleSignUpFormVisibilityHandler)
  .case(action.togglePlayerTermListVisibility, togglePlayerTermListVisibilityHandler)
  .case(action.showSignUpForm, showSignUpFormHandler)
  .case(action.setHeaderType, setHeaderTypeHandler)
  .case(action.setHeaderActions, setHeaderActionsHandler)
  .case(action.showDownloadAgreementModal, showDownloadAgreementModalHandler)
  .case(action.clearUIState, clearUIStateHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/ui.ts